module.exports = __webpack_public_path__ + "img/personalInfo.6abc9c7d.svg";